import React from "react";
import { Item } from "../types";

interface ItemListProps {
  items: Item[];
  selectedItem: Item | null;
  onItemSelect: (item: Item) => void;
}

const ItemList: React.FC<ItemListProps> = ({
  items,
  selectedItem,
  onItemSelect,
}) => {
  return (
    <div className="space-y-2 max-h-96 overflow-y-auto">
      {items.length === 0 ? (
        <div className="text-center text-gray-500 py-8">
          <p>Geen beschikbare items meer</p>
        </div>
      ) : (
        items.map((item) => (
          <div
            key={item.id}
            onClick={() => onItemSelect(item)}
            className={`flex items-center p-3 rounded-lg border cursor-pointer transition-all duration-200 ${
              selectedItem?.id === item.id
                ? "border-blue-500 bg-blue-50 shadow-md"
                : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
            }`}
          >
            <div className="flex-shrink-0">
              <img
                src={item.thumbnail}
                alt={item.name}
                className="w-12 h-12 rounded object-cover"
              />
            </div>
            <div className="ml-4 flex-1">
              <h3 className="text-sm font-medium text-gray-900">{item.name}</h3>
              <p className="text-sm text-gray-500">Kleur: {item.color}</p>
              <p className="text-sm font-medium text-gray-900">
                €{item.price.toFixed(2)}
              </p>
            </div>
            {selectedItem?.id === item.id && (
              <div className="flex-shrink-0">
                <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center">
                  <svg
                    className="w-4 h-4 text-white"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default ItemList;
